// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3hziZ","icon":"SortAdornment_icon__1pfEn","up":"SortAdornment_up__3BnKf","down":"SortAdornment_down__3Nfva","active":"SortAdornment_active__2M3Ub"};